const PEOPLE = [
    "momo", "blasie", "jersey", "mark", "marty", "barbie", "kenny", "doug", "leroy", "spence", "ledyard", "alan", "sickle", "mattmatt", "brendan", "timtim", "lucas", "turner",
    "milkman", "broc", "mudjug", "russel", "justin", "woodsy", "dennis", "natalie", "jacob", "jules", "ethan", "erica", "jenna", "konnor", "adam", "nick", "smart",
    "kesha", "asif", "colin", "graham", "griffin", "dudak", "ryan", "Skeg", "Craig", "colton", "josue", "kevin", "nathan", "pete", "aaron", "davey", "eddie", "sponse", "daniel",
    "olivia", "anthony"
]

export default PEOPLE;